/**
 * @format
 * @flow
 */
import { stat } from 'fs';
import * as Task from '../constants/reducers/Task';

const initialState = {
  currentTask: {
    Items: [],
    next_pages: 0,
    page_count: 0,
    prev_pages: 0,
    totalItem: 0,
    totalRewal: 0
  },
  oldTask: {
    Items: []
  },
  currentTaskLoaded: false,
  oldTaskLoaded: false,
  taskDetail: {},
  taskDetailLoaded: false,
  taskDeleted: false,
  categories: [],
  categoriesLoaded: false,
  taskEdited: false,
  licensesLoaded: false,
  licenses: [],
  createdTask: false,
  paymentInfo: {
    Items: [],
    next_pages: 0,
    prev_pages: 0,
    totalItem: 0,
    totalRewal: 0
  },
  invoiceInfo: {
    invoices: [],
    totalRewal: ''
  },
  approvedTask: false,
  canceledFromEnterprise: false,
  canceledFromUser: false,
  reviewSent: false,
  participantDetail: {},
  contractContent: {},
  contractLoaded: false,
  feeRate: '0%',
  consumptionTax: '10%',
  searchArgs: {
    status: '現在のタスク',
    date: [0, 0],
    title: '',
    enterpriseId: '',
    taskCategoryId: '',
    license1: '',
    taskStatus: '',
    page: 1
  }
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case Task.SEND_REVIEW:
      return { ...state, reviewSent: true };
    case Task.RESET_SEND_REVIEW:
      return { ...state, reviewSent: false };
    case Task.CANCEL_TASK_FROM_USER:
      return { ...state, canceledFromUser: true };
    case Task.RESET_CANCEL_TASK_FROM_USER:
      return { ...state, canceledFromUser: false };
    case Task.CANCEL_TASK_FROM_ENTERPRISE:
      return { ...state, canceledFromEnterprise: true };
    case Task.RESET_CANCEL_TASK_FROM_ENTERPRISE:
      return { ...state, canceledFromEnterprise: false };
    case Task.APPLY_TASK:
      return { ...state, approvedTask: true };
    case Task.RESET_APPLY_TASK:
      return { ...state, approvedTask: false };
    case Task.SAVE_PAYMENT_INFO:
      return {
        ...state,
        paymentInfo: action.data,
        feeRate: action.data.feeRate,
        consumptionTax: action.data.consumptionTax
      };
    case Task.SAVE_INVOICE_INFO:
      return { ...state, invoiceInfo: action.data };
    case Task.RESET_PAYMENT_INFO:
      return {
        ...state,
        paymentInfo: {
          Items: [],
          next_pages: 0,
          prev_pages: 0,
          totalItem: 0,
          totalRewal: 0
        }
      };
    case Task.RESET_INVOICE_INFO:
      return {
        ...state,
        invoiceInfo: {
          invoices: [],
          totalRewal: ''
        }
      };
    case Task.REGISTER_TASK:
      return { ...state, createdTask: true };
    case Task.RESET_REGISTER_TASK:
      return { ...state, createdTask: false };
    case Task.LICENSES_SAVE:
      return { ...state, licenses: action.data, licensesLoaded: true };
    case Task.SAVE_CATEGORY:
      // console.log('たすくカテゴリ', action)
      return { ...state, categories: action.data, categoriesLoaded: true };
    case Task.GET_MY_TASKS:
      // console.log('tsks', action.data)
      return { ...state, currentTask: action.data, currentTaskLoaded: true };
    case Task.GET_OLD_TASKS:
      return { ...state, oldTask: action.data, oldTaskLoaded: true };
    case Task.RESET_OLD_TASKS:
      return {
        ...state,
        oldTask: {
          items: []
        },
        oldTaskLoaded: false
      };
    case Task.RESET_MY_TASKS:
      return {
        ...state,
        currentTask: {
          Items: []
        },
        currentTaskLoaded: false
      };
    case Task.GET_TASK_DETAIL:
      console.log('タスク詳細', action.data);
      return { ...state, taskDetail: action.data, taskDetailLoaded: true };
    case Task.RESET_TASK_DETAIL:
      return {
        ...state,
        taskDetail: {},
        taskDetailLoaded: false,
        taskDeleted: false
      };
    case Task.RESET_DELETE_TASK:
      return { ...state, taskDeleted: false };
    case Task.DELETE_TASK:
      return { ...state, taskDeleted: true };
    case Task.EDIT_TASK:
      return { ...state, taskEdited: true };
    case Task.EDIT_TASK_RESET:
      return { ...state, taskEdited: false };
    case Task.SET_PARTICIPANT:
      return { ...state, participantDetail: action.data };
    case Task.TASK_CONTRACT_CONTENT:
      return { ...state, contractContent: action.data, contractLoaded: true };
    case Task.RESET_CONTRACT_CONTENT:
      return { ...state, contractContent: {}, contractLoaded: false };
    case Task.SET_TASK_STATUS:
      console.log('TCL: reducer -> action', action);
      return { ...state, searchArgs: action.data };
    default:
      return state;
  }
}
